import ElementPlus from 'element-plus';
import 'element-plus/packages/theme-chalk/lib/index.css';
import '../assets/css/element-variables.scss';
import locale from 'element-plus/lib/locale/lang/zh-cn';
import { App } from 'vue';

export default (app: App) => {
  app.use(ElementPlus, { size: 'medium', locale });
};
